<template>
  <div class="settings-header">
    <h1 class="page-title font_regular font_600 text_20">
      <!-- <woot-sidemenu-icon></woot-sidemenu-icon> -->
      <back-button
        v-if="showBackButton"
        :button-label="backButtonLabel"
        :back-url="backUrl"
      />
      <!-- <fluent-icon v-if="icon" :icon="icon" :class="iconClass" /> -->
      <slot></slot>
      <span class="">{{ headerTitle }}</span>
    </h1>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import BackButton from '../../../components/widgets/BackButton.vue';

export default {
  components: {
    BackButton,
  },
  mixins: [
    // adminMixin
  ],
  props: {
    headerTitle: {
      default: '',
      type: String,
    },
    icon: {
      default: '',
      type: String,
    },
    showBackButton: { type: Boolean, default: false },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    backButtonLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
    //   currentUser: 'getCurrentUser',
    }),
    iconClass() {
      return `icon ${this.icon} header--icon`;
    },
  },
};
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

</style>